import type { CfiRating } from '~/data/hooks/useCfi';

export const ratingLabels: Record<CfiRating, string> = {
  favorable: 'Favorable',
  neutral: 'Neutral',
  unfavorable: 'Unfavorable',
  not_applicable: 'Not applicable',
};

export const ratingColors: Record<CfiRating, 'success' | 'info' | 'error' | 'default'> = {
  favorable: 'success',
  neutral: 'info',
  unfavorable: 'error',
  not_applicable: 'default',
};
